export const parseDateString = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const formatSchedule = (start, end, lang = 'ca') => {
  if (!(start && end)) {
    return '';
  }

  const dateStart = new Date(start.replace(' ', 'T'));
  const dateEnd = new Date(end.replace(' ', 'T'));

  const dayName = dateStart.toLocaleDateString(lang, { weekday: 'long' });
  const hourStart = `${String(dateStart.getHours()).padStart(2, '0')}.${String(dateStart.getMinutes()).padStart(2, '0')}`;
  const hourEnd = `${String(dateEnd.getHours()).padStart(2, '0')}.${String(dateEnd.getMinutes()).padStart(2, '0')}`;

  return `${dayName.charAt(0).toUpperCase() + dayName.slice(1)}, ${hourStart} - ${hourEnd} h`;
};
